export const COMPLAINT_SEVERITY_DESCRIPTIONS = {
  critical:
    'Device is unusable for its intended purpose. No reasonable workaround exists.',
  major:
    'Device is usable but with significant limitations. Workaround available but inconvenient.',
  minor:
    'Device fully usable. Issue does not impact clinical use or functionality.',
};

export function getComplaintSeverityDescription(severity) {
  const key = (severity || 'minor').toLowerCase();
  return COMPLAINT_SEVERITY_DESCRIPTIONS[key] || COMPLAINT_SEVERITY_DESCRIPTIONS.minor;
}
